import authHeader from "./auth-header";
import http from "./http-common";

class ParticipantsDataService {
	create(event, user) {
		return http.post("/participants", { event, user }, { headers: authHeader() });
	}

	checkParticipation(event, user) {
		return http.get(`/participants/user/${user.id}/event/${event._id}`, { headers: authHeader() });
	}

	getEventParticipantsCount(event) {
		return http.get(`/participants/event/${event._id}/count`);
	}

	getEventParticipantsExcel(event) {
		return http.get(`/participants/event/${event._id}/excel`, { headers: authHeader() });
	}

	getEventParticipantsList(event) {
		return http.get(`/participants/event/${event._id}`, { headers: authHeader() });
	}

	getUserEvents(user) {
		return http.get(`/participants/user/${user.id}`, { headers: authHeader() });
	}

	userLeaveEvent(eventId, userId) {
		return http.put(`/participants/user/${userId}/event/${eventId}`, {}, { headers: authHeader() });
	}

	getExtendedEventData(pId, eId) {
		return http.get(`/participants/p/${pId}/e/${eId}`, { headers: authHeader() });
	}
}

export default new ParticipantsDataService();
